export const clientsService = async (data, zonaSelected)=>{ 
    const data_ = [];
    await Promise.all(data
        .filter(el=> el.Servicios.length > 0 && el.Status === 'Activo')
        .map(async(el)=>{
            const { Nombres, _id:idCliente } = el;
            const Correo = el.Correo[0].correo;
            const Celular = el.Celular[0].celular;
            await Promise.all(el.Servicios.map(sub=>{
                if(sub.ZonaService === zonaSelected) 
                data_.push({
                    ...sub,
                    idCliente, 
                    Nombres, 
                    Correo, 
                    Celular,
                    Zonas:el.Zonas
                })
                return 'ok';
            }))
            return 'ok';
    })); 
    return data_; // RETORNA {...SERVICIO, IDCLIENTE, CORREO, NOMBRES, CELULAR}
}
